import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Accordion, AccordionDetails, AccordionSummary, Grid, Tooltip, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Delete, Save } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import StateTransitionListItemComponent from './StateTransitionListItemComponent';
import StateTransitionListItemSummary from './StateTransitionListItemSummary';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { Typography } from '@totalsoft/rocket-ui';

const StateTransitionListComponent = ({
  automaticStateTransitionRules,
  states,
  onSave,
  onDelete,
  onPropertyChanged,
  onExpandChange,
  validation
}) => {
  const { t } = useTranslation();
  return automaticStateTransitionRules.map((item, index) => {
    const header = <StateTransitionListItemSummary stateTransition={item} />;

    function ValidationError() {
      return (
        <Fragment>
          <Grid item xs={12}>
            <Typography color='error'>{validation |> getErrors}</Typography>
          </Grid>
        </Fragment>
      );
    }
    return (
      <Grid key={index} item xs={12} sx={{ marginBottom: '35px!important' }}>
        <Accordion expanded={item.isExpanded} onChange={(_, isExpanded) => onExpandChange(isExpanded, index)}>
          <AccordionSummary sx={{ width: '100%' }} expandIcon={<ExpandMoreIcon />}>
            {(item.isExpanded || (!item.isExpanded && !header)) && (
              <Grid container spacing={1} justifyContent='flex-end' onClick={event => event.stopPropagation()}>
                <Grid item>
                  <Tooltip title={t('AutomaticStateTransitionRules.Save')}>
                    <div>
                      <IconButton
                        color='primary'
                        onClick={onSave(index)}
                        disabled={!item.changed || !(validation[index] |> isValid) || (validation |> getErrors) !== ''}
                      >
                        <Save />
                      </IconButton>
                    </div>
                  </Tooltip>
                </Grid>
                <Grid item>
                  <Tooltip title={t('AutomaticStateTransitionRules.Delete')}>
                    <div>
                      <IconButton color='primary' onClick={onDelete(index)}>
                        <Delete />
                      </IconButton>
                    </div>
                  </Tooltip>
                </Grid>
              </Grid>
            )}
            {!item.isExpanded && <div style={{ width: '100%' }}>{header}</div>}
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid container item xs={12}>
                <ValidationError />
              </Grid>
              <StateTransitionListItemComponent
                key={index}
                index={index}
                item={item}
                states={states}
                onPropertyChanged={onPropertyChanged}
                validation={validation}
              />
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    );
  });
};

StateTransitionListComponent.propTypes = {
  automaticStateTransitionRules: PropTypes.array.isRequired,
  states: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  onExpandChange: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default StateTransitionListComponent;
